var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDocumentsRegulatory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25V3C1 1.89543 1.89543 1 3 1H11.2179C12.0594 1 12.811 1.52681 13.098 2.31791L14.2822 5.58209C14.5692 6.37319 15.3207 6.9 16.1623 6.9H35.9693C37.0858 6.9 37.9861 7.81408 37.9691 8.93042L37.7242 25.0304C37.7076 26.123 36.8171 27 35.7244 27H3C1.89543 27 1 26.1046 1 25Z",
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32V3C1 1.89543 1.89543 1 3 1H11.2179C12.0594 1 12.811 1.52681 13.098 2.31791L14.2822 5.58209C14.5692 6.37319 15.3207 6.9 16.1623 6.9H35.9773C37.0907 6.9 37.9897 7.80924 37.9772 8.92257L37.7165 32.0226C37.7042 33.1183 36.8124 34 35.7167 34H3C1.89543 34 1 33.1046 1 32Z",
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69698 13.8287C4.78028 13.3497 5.19602 13 5.68219 13H40.6222C41.2429 13 41.7137 13.5597 41.6074 14.1713L38.303 33.1713C38.2197 33.6503 37.804 34 37.3178 34H2.37785C1.75705 34 1.28627 33.4403 1.39263 32.8287L4.69698 13.8287Z",
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentsRegulatory);
export default __webpack_public_path__ + "static/media/icon-documents-regulatory.38ab52b7064cdc455f8d1061252c3c4e.svg";
export { ForwardRef as ReactComponent };